import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class EditButtonModel extends ButtonBase {
    label: string = 'Edit';
    action: string = ACTION_STATUS.edit;
    matIconName: string = 'edit';
    colorClass: string = 'color-warning-500';
}